import{useGroups}from'soapbox/api/groups';/**
 * Determine the correct URL to use for /groups.
 * If the user does not have any Groups, let's default to the discovery tab.
 * Otherwise, let's default to My Groups.
 *
 * @returns String (as link)
 */var useGroupsPath=function useGroupsPath(){var _useGroups=useGroups(undefined,1),groups=_useGroups.groups;return groups.length>0?'/groups':'/groups/discover';};export{useGroupsPath};